// extracted by mini-css-extract-plugin
export default {"headingButton":"iqcActivity_headingButton__42uNy","iqcContainer":"iqcActivity_iqcContainer__7jNMy"};